module.exports = __webpack_public_path__ + "static/media/timer.56bf5ede.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/timer.svg
// module id = ./src/assets/icons/timer.svg
// module chunks = 0